import React from 'react';

const AvatarImage = ({ src, alt, onError }) => {
  return (
    <img
      key={src}
      src={src}
      alt={alt}
      className="avatar-image"
      onError={onError}
      draggable="false"
      loading="lazy"
    />
  );
};

export default AvatarImage;